var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import Vue from 'vue';
import Card from 'src/components/Card/Card';
import rpc from 'src/api/rpc';
import GenericTable from 'src/components/GenericTable/GenericTable.vue';
import LineGraph from 'src/components/Graphs/LineGraph.vue';
import dateToISODate from 'src/utils/dateOperations/dateToISODate';
export default Vue.extend({
    name: 'ClassUserRenderer',
    components: { Card, GenericTable, LineGraph },
    props: {
        userIdParam: { type: Number, required: true }
    },
    data() {
        return {
            visible: false,
            currentTab: 'resFrequencyGraph',
            data: []
        };
    },
    computed: {
        columns() {
            const a = this.$store.getters['ci.reservations/columns'];
            const b = a.filter((col) => col.name !== 'user_id');
            return b;
        },
        graphData() {
            const checkedInRes0 = JSON.parse(JSON.stringify(this.data.filter((r) => r.status_id === 1)));
            const checkedInRes = checkedInRes0.map(r => { return Object.assign(Object.assign({}, r), { checkinDate: Date.parse(r.class_date || r.creation_date) }); });
            const cDates = checkedInRes.map(r => r.checkinDate);
            const firstCheckInDate = Math.min(...cDates);
            const lastCheckInDate = Math.max(...cDates);
            const dates = [];
            const counts = [];
            let j = firstCheckInDate;
            let i = 0;
            for (i = firstCheckInDate; i < lastCheckInDate; i = i + 8.64e+7) { // 1 day step
                const date = new Date(i);
                dates.push(dateToISODate(date));
                const count = (checkedInRes.filter(r => r.checkinDate >= j && r.checkinDate < i + 2.592e+9) || []).length; // 30 day rolling average
                counts.push(count);
                j = i;
            }
            return { dates, series: [{ name: '30-day rolling average', data: counts }] };
        }
    },
    watch: {
        visible: {
            immediate: true,
            handler(newVal) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (newVal === true) {
                        const response = yield rpc('ci.reservations_fetch', { filters: { user_id: { containedIn: [this.userIdParam] } }, supress_server_side_pagination: true });
                        this.data = response.data || [];
                    }
                });
            }
        }
    },
    methods: {}
});
